import React from 'react';
import styled from 'styled-components';
import {GetGlobalTheme} from '@src/tools/displayTools';
import {colours} from '@src/styles/Style';
import {TextSmall} from '@src/styles/primitiveComponents';

const TooltipContent = styled.span`
  visibility: hidden;
  width: auto;
  background-color: ${colours[GetGlobalTheme()].primary};
  color: ${colours[GetGlobalTheme()].white};
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
  height: 18px;
`;

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipContentContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${TooltipContent} {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipArrow = styled.span`
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: ${colours[GetGlobalTheme()].primary} transparent transparent transparent;
`;

type ToolTipProps = {
  children: React.ReactNode;
  tooltipText: string;
};

const ToolTip: React.FC<ToolTipProps> = ({children, tooltipText}) => {
  const toolTipTextLengthLimit = 18;
  const toolTipShortenedSuffix = '...';

  function getToolTipText() {
    if (tooltipText.length > toolTipTextLengthLimit) {
      return tooltipText.slice(0, toolTipTextLengthLimit) + toolTipShortenedSuffix;
    }
    return tooltipText;
  }

  return (
    <TooltipContainer title="">
      <TooltipContentContainer>
        {children}
        <TooltipContent>
          <TextSmall style={{color: colours[GetGlobalTheme()].white, whiteSpace: 'nowrap', bottom: 2}}>
            {getToolTipText()}
          </TextSmall>
          <TooltipArrow />
        </TooltipContent>
      </TooltipContentContainer>
    </TooltipContainer>
  );
};

export default ToolTip;
